import { Container } from 'react-bootstrap';
import styled from 'styled-components';

export const HomeContainer = styled(Container)`
  margin: 5px 0;
  padding: 5px 0;
`;

export const HomeDescription = styled.p`
  color: #707070;
  text-align: justify;
  font-size: 16px;
  line-height: 24px;
  margin-top: 0.5rem;
`;
